<div class="bg-white h-full rounded-lg border border-gray-200 p-5">
  <h2 class="text-base font-semibold text-gray-900 mb-4">{{ title }}</h2>

  <div class="space-y-3.5">
    @for (item of items; track item.label) {
      <div class="flex items-start gap-3">
        <div class="text-sm text-gray-600 w-28 flex-shrink-0 pt-0.5">
          {{ item.label }} :
        </div>
        <div class="text-sm font-medium text-gray-900">
          {{ item.value || "-" }}
        </div>
      </div>
    }
  </div>
</div>
